import React from "react";

export default function StatusBadge({ children, tone = "neutral" }) {
  return <span className={`rr-badge ${tone}`}>{children}</span>;
}
